import { render } from "./App.vue?vue&type=template&id=5213cfd2&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5213cfd2&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/kamigame-game-tool/kamigame-game-tool/packages/legends-arceus/move-search/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5213cfd2"]])

export default __exports__